/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 发送邮箱验证
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class SendEmailParams {
  constructor(public email: string, public stepKey: string) {}
}

export default async function (
  params: SendEmailParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/email-sending`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
